import { WarningIcon as WarningVectorIcon } from 'src/shared/components/icons/toasts/warning-icon'

export default function WarningIcon() {
  return (
    <div className="flex size-[30px] shrink-0 items-center justify-center rounded-full bg-[#FF8800] bg-opacity-20 text-[#FF8800]">
      <WarningVectorIcon size={15} />
    </div>
  )
}
